import { render, staticRenderFns } from "./teacher-list.vue?vue&type=template&id=d9b3b16e&scoped=true&"
import script from "./teacher-list.vue?vue&type=script&lang=js&"
export * from "./teacher-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b3b16e",
  null
  
)

export default component.exports